/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ListaPreguntaMEL } from './listaPreguntaMEL';
import { RolModeloMEL } from './rolModeloMEL';

export interface RegistroME { 
    avatarId?: number;
    tipoIdentificacionId?: number;
    identificacion?: string;
    nombre?: string;
    nombreUsuario?: string;
    contrasenia?: string;
    correo?: string;
    telefono?: string;
    otp?: string;
    preguntas?: Array<ListaPreguntaMEL>;
    roles?: Array<RolModeloMEL>;
    envioCorreo?:boolean;
    envioSms?:boolean;
}